import { useState } from "react";

import { Box, Collapse, CollapseProps } from "@mui/material";
import {
  Button,
  ChevronDownIcon,
  ChevronUpIcon,
  FilterLinesIcon,
  Typography,
} from "components";
import { gray } from "configs/colors";

interface Props extends Pick<CollapseProps, "unmountOnExit"> {
  children?: React.ReactNode;
}

const IndexComponent: React.FC<Props> = ({ children, unmountOnExit }) => {
  const [open, setOpen] = useState(true);

  const toggle = () => {
    setOpen((prev) => !prev);
  };

  return (
    <>
      <Box display="flex" alignItems="center" flexWrap="wrap" gap={4}>
        <Typography
          type="TextLG"
          fontWeight={600}
          flex="0 0 auto"
          sx={{
            opacity: open ? 1 : 0,
            transition: "opacity 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
          }}
        >
          Filter Elements
        </Typography>
        <Box display="flex" justifyContent="flex-end" flex={1}>
          <Button
            variant="outlined"
            color="inherit"
            size="md"
            sx={{
              display: "flex",
              flex: "0 0 auto",
              background: gray[50],
            }}
            useTypography
            typographyProps={{ color: gray[800] }}
            startIcon={
              <FilterLinesIcon fontSize="small" sx={{ color: gray[700] }} />
            }
            endIcon={
              open ? (
                <ChevronUpIcon fontSize="small" sx={{ color: gray[800] }} />
              ) : (
                <ChevronDownIcon fontSize="small" sx={{ color: gray[800] }} />
              )
            }
            onClick={toggle}
          >
            Filters
          </Button>
        </Box>
      </Box>

      {/* Filter section */}
      <Collapse in={open} unmountOnExit={unmountOnExit}>
        {children}
      </Collapse>
    </>
  );
};

export default IndexComponent;
